<template>
  <div class="class" v-model="event">
    <alert :shown="showAlert" :title="alertTitle" :type="alertType" :content="alertContent" />
    <h1 v-if="!smallHeader && !smallerHeader">{{ event.name }}</h1>
    <h2 v-if="smallHeader">{{ event.name }}</h2>
    <h3 v-if="smallerHeader">{{ event.name }}</h3>
    <div class="grid-container">
      <div class="metadata">
        <p><b>Date:</b> <span>{{ formattedDate }}</span></p>
        <p><b>Times: </b><span>{{ startTime }}</span> - <span>{{ endTime }}</span></p>
        <!-- <p v-if="event.repeating"><b>Days: </b><span class="days">{{ event.days.join(", ") }}</span></p> -->
        <p><b>Level: </b> <span v-if="event.level">{{ event.level.name }}</span></p>
        <p><b>Space: </b> <span v-if="event.level">{{ event.space.name }}</span></p>
        <p v-if="event.description"><b>Description: </b>{{ event.description }}</p>
      </div>
      <div class="participants">
        <p><b>Fencers - {{ event.fencers.length }} / {{ event.seats }}:</b></p>
        <ul v-if="event.fencers && event.fencers.length > 0">
          <li v-for="fencer in event.fencers">
            {{ fencer.firstname }} {{ fencer.lastname }}
          </li>
        </ul>
        <p v-else>No fencers registered yet</p>
        <p class="gap"><b>Coaches:</b></p>
        <ul v-if="event.coaches && event.coaches.length > 0">
          <li v-for="coach in event.coaches">
            <router-link :to="'/coach/'+coach.id">
              <span>{{ coach.firstname }} </span>
              <span>{{ coach.lastname }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="actions" v-if="me.role == 'coach' && me.isOwner">
      <button class="btn btn-primary btn-sm" v-on:click.prevent="edit" title="Edit this event"><i class="icon icon-edit"></i></button>&nbsp;
      <button class="btn btn-primary btn-sm" v-on:click.prevent="deleteIt" title="Delete this event"><i class="icon icon-delete"></i></button>&nbsp;
    </div>
    <div class="edit-controls" v-if="me.role == 'fencer'">
      <div v-if="event.regClosed">Registration closed</div>
      <button class="btn btn-primary btn-sm" v-on:click.prevent="register" v-if="!event.registered && !event.regClosed" :data-id="event.id" :disabled="event.fencers.length >= event.seats ? 'disabled' : false">Register for class</button>
      <button class="btn btn-primary btn-sm" v-on:click.prevent="drop" v-else-if="!event.regClosed" :data-id="event.id">Drop class</button>
    </div>
    <modal v-if="showModal" @close="showModal = false">
      <h3 slot="header">Edit class</h3>
      <div slot="body">
        <newclass v-bind:selected="selected" v-bind:editing="editing" />
      </div>
      <div slot="footer"></div>
    </modal>
    <modal v-if="showDeleteModal" @close="showDeleteModal = false">
      <h3 slot="header">Delete class?</h3>
      <div slot="body">
        <p>Are you sure you want to delete the class <b>{{ toDeleteTitle }}</b>? This action cannot be undone.</p>
        <p>Notifications will be sent to any fencers who are registered for this.</p>
        <div class="actions">
          <button class="btn" @click="showDeleteModal = false">Cancel</button>&nbsp;
          <button class="btn btn-error" v-on:click.prevent="deleteItForReal">Delete</button>&nbsp;
          <button class="btn btn-error" v-on:click.prevent="deleteItForRealAll">Delete all in series</button>
        </div>
      </div>
      <div slot="footer"></div>
    </modal>
  </div>
</template>

<script>
import config from "../config"
import modal from "../components/Modal"
import newclass from "../coachcomponents/NewClass"
import { EventBus } from "../main"
import alert from "../components/Alert"

export default {
  name: 'class',
  props : [
    "smallHeader",
    "smallerHeader",
    "passedEvent",
    "passedMe"
  ],
  components : {
    modal,
    newclass,
    alert
  },
  data () {
    return {
      event : { fencers : [] },
      selected : {},
      formattedDate : "",
      me : "",
      showModal : false,
      showDeleteModal : false,
      editing : true,
      showAlert : "",
      alertTitle : "",
      alertType : "",
      alertContent : "",
      startTime : "",
      endTime : ""
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getData()
    })
  },
  beforeRouteUpdate (to, from, next) {
    next(vm => {
      vm.getData()
    })
  },
  created () {
    if(this.passedEvent){
      this.setData(this.passedEvent, this.passedMe)
    } else if(this.event == ""){
      this.getData()
    }

    EventBus.$on("eventEdited", (e) => {
      if(this.event.id == e.id || this.$router){
        // TODO: this doesn't work when you change multiple events from the class view page...
        //if(this.$router && this.event.id != e.id) window.location.pathname = "class/"+e.id
        this.showModal = false
        this.showAlert = "shown"
        this.alertType = "success"
        this.alertTitle = "Edits successfully saved!"
        this.alertContent = "Your edits were successfully saved!"
        this.getData()
      }
    })

    EventBus.$on("hideAlert", () => {
      this.showAlert = ""
    })

  },
  methods : {
    setData(d, d2){
      this.event = d
      this.me = d2
      this.formattedDate = this.formatDate(this.event.date)
      this.startTime = this.formatTime(d.timestart)
      this.endTime = this.formatTime(d.timeend)
    },
    getData(){
      return new Promise((resolve, reject) => {
        let id = this.passedEvent ? this.passedEvent.id : this.$route.params.uuid
        fetch(config.baseUrl+"events/event/"+id, {
          credentials : "include"
        })
        .then(e => {
          return e.json()
        }).then(j => {
          fetch(config.baseUrl+"user/me/", {
            credentials : "include"
          }).then(e => {
            return e.json()
          }).then(j2 => {
            this.setData(j, j2)
            resolve()
          })
        })
      })
    },
    formatDate(date){
      let newDate = new Date(date),
          month = this.getMonth(newDate),
          day = this.getDay(newDate)
      return day + ", " + month +" "+ newDate.getUTCDate()+", "+newDate.getUTCFullYear()
    },
    getDay(date){
      let day = ""
      switch (date.getUTCDay()) {
        case 0:
          day = "Sunday"
          break
        case 1:
          day = "Monday"
          break
        case 2:
          day = "Tuesday"
          break
        case 3:
          day = "Wednesday"
          break
        case 4:
          day = "Thursday"
          break
        case 5:
          day = "Friday"
          break
        case 6:
          day = "Saturday"
          break
      }
      return day
    },
    getMonth(date){
      let month = ""
      switch (date.getUTCMonth()) {
        case 0:
          month = "January"
          break
        case 1:
          month = "February"
          break
        case 2:
          month = "March"
          break
        case 3:
          month = "April"
          break
        case 4:
          month = "May"
          break
        case 5:
          month = "June"
          break
        case 6:
          month = "July"
          break
        case 7:
          month = "August"
          break
        case 8:
          month = "September"
          break
        case 9:
          month = "October"
          break
        case 10:
          month = "November"
          break
        case 11:
          month = "December"
          break
      }
      return month
    },
    formatTime : function(time){
      let newTime = "",
          splits = time.split(":"),
          hour = 0,
          end = ""
      if(splits[0] > 12){
        hour = parseInt(splits[0]) - 12
        end = "pm"
      } else {
        hour = parseInt(splits[0])
        if(hour == 12) end = "pm"
        else end = "am"

        if(hour == 0) hour = 12
      }

      if(splits[1] != "00"){
        newTime = hour + ":" + splits[1] + " " + end
      } else {
        newTime = hour + " " + end
      }

      return newTime
    },
    edit(e){
      this.selected = this.event
      this.showModal = true
    },
    deleteIt(e){
      let id = e.target.nodeName.toLowerCase() == "button" ? e.target.getAttribute("data-id") : e.target.parentNode.getAttribute("data-id")
      this.eventToDelete = this.event
      this.toDeleteTitle = this.event.name
      this.showDeleteModal = true
    },
    deleteItForReal(e){
      fetch(config.baseUrl+"events/delete", {
        method : "DELETE",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body : JSON.stringify({
          id : this.eventToDelete.id
        })
      }).then(e => {
        this.showDeleteModal = false
        this.showAlert = "shown"
        this.alertTitle = "Deleted"
        this.alertType = "warning"
        this.alertContent = "Class was successfully deleted."
        if(!this.passedEvent){
          // forward home
          this.$router.push("/")
        } else {
          EventBus.$emit("classDeleted")
        }
      })
    },
    deleteItForRealAll(e){
      fetch(config.baseUrl+"events/delete", {
        method : "DELETE",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body : JSON.stringify({
          id : this.eventToDelete.id,
          deleteAll : true,
          parent : this.eventToDelete.parent
        })
      }).then(e => {
        this.showDeleteModal = false
        this.showAlert = "shown"
        this.alertTitle = "Deleted"
        this.alertType = "warning"
        this.alertContent = "Classes were successfully deleted."
        if(!this.passedEvent){
          // forward home
          this.$router.push("/")
        } else {
          EventBus.$emit("classDeleted")
        }
      })
    },
    register(e){
      this.selected = this.event
      fetch(config.baseUrl+"events/register/"+this.selected.id, {
        credentials : "include",
        method : "PUT"
      }).then(e => {
        return e.json()
      }).then(j => {
        this.getData()
        .then(() => {
          if(j.type == "rule_violation" && j.error){
            this.showAlert = "shown"
            this.alertTitle = "Registration unsuccessful"
            this.alertType = "error"
            this.alertContent = j.error
          }

          if(j.rule && j.rule.message){
            this.showAlert = "shown"
            this.alertTitle = "Warning"
            this.alertType = "warning"
            this.alertContent = j.rule.message
          }
        })
      }).catch(err => {
        console.log(err)
      })
    },
    drop(e){
      this.selected = this.event
      fetch(config.baseUrl+"events/drop/"+this.selected.id, {
        credentials : "include",
        method : "PUT"
      }).then(e => {
        return e.json()
      }).then(j => {
        this.getData()
        .then(e => {
          this.event = e
        })
      }).catch(err => {
        console.log(err)
      })
    }
  },
}
</script>

<style lang="scss">
  .class {
    padding-right: 20px;
    .grid-container {
      display: grid;
      grid-template-columns: auto 300px;
    }
    .days {
      text-transform: capitalize;
    }
    .metadata {
      p {
        margin-bottom: 0;
        &:last-child {
          margin-top: 20px;
          max-width: 60ch;
        }
      }
    }
    .participants {
      p {
        margin-bottom: 0;
        &.gap {
          margin-top: 20px;
        }
      }
      ul {
        margin-top: 0;
        li {
          margin-top: 0;
          margin-bottom: 5px;
        }
      }
    }
    @media (max-width:640px){
      .participants {
        margin-top: 20px;
      }
      .metadata, .participants {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }
    .actions,
    .edit-controls {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>
